import React, { useEffect, useState } from 'react'
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase/firebase';
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";

import LoginScreen from '../Components/auth/LoginScreen';
import RegisterScreen from '../Components/auth/RegisterScreen';
import Navbar from '../Components/Navbar';
import AdminScreen from '../Editor/Screens/AdminScreen';
import LienzoScreen from '../Editor/Screens/LienzoScreen';
import MainScreen from '../Editor/Screens/MainScreen';
import MisDiagramas from '../Editor/Screens/MisDiagramas';
import PerfilScreen from '../Editor/Screens/PerfilScreen';

import { Backdrop } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import ResetPassScreen from '../Editor/Screens/ResetPassScreen';
import ColeccionesScreen from '../Editor/Screens/ColeccionesScreen';

const AppRouter = () => {

  const [firebaseUser, setFirebaseUser] = useState(false);

  useEffect(() => {
    
    onAuthStateChanged(auth, (user) => {

      if (user) {
          setFirebaseUser(user);
        // ...
      } else {
        setFirebaseUser(null);
      }

    });
  }, [])
  

  return firebaseUser !== false ? (

    <Router>
        <div className='container'>
          <Navbar firebaseUser={firebaseUser}/>
          <Routes>
              <Route path='/login' element={<LoginScreen/>}/>
              <Route path='/register' element={<RegisterScreen/>}/>
              <Route path='/lienzo' element={<LienzoScreen/>}/>
              <Route path='/diagramas' element={<MisDiagramas/>} />
              <Route path='/perfil' element={ <PerfilScreen/> } />
              <Route path='/admin' element={<AdminScreen/>} />
              <Route path='/reset' element={<ResetPassScreen/>} />
              <Route path='/colecciones' element={<ColeccionesScreen/>} />
              <Route path='/' element={<MainScreen/>}/>
              <Route path='*' element={<Navigate replace to='/'/>} />
          </Routes>
        </div>
    </Router>
  ) : 
  (
    <Backdrop
        open={true}
        sx={{ color: '#fff', 
        zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <CircularProgress open color="inherit" />
    </Backdrop>
  )
}

export default AppRouter;